import { cn } from '@/lib/utils'

import { Skeleton, useReviewsCarouselVariants } from '../../../Theme'
import { SKELETON_COUNTS } from '../../constants'

import type { ReviewsCarouselSkeletonProps } from '../../types'

/**
 * ReviewsCarouselSkeleton - Layout-stable placeholder for the reviews section.
 * Mirrors the 2 / 3 / 5 responsive grid of the loaded carousel; default count fills
 * the widest (xl, 5-column) row so no cell is left empty.
 */
export function ReviewsCarouselSkeleton({ className, count = SKELETON_COUNTS.reviewsCarousel }: ReviewsCarouselSkeletonProps) {
  const {
    reviewsCarouselSectionVariants,
    reviewsCarouselSkeletonGridVariants,
    reviewsCarouselSkeletonItemVariants,
  } = useReviewsCarouselVariants()

  return (
    <section
      className={cn(reviewsCarouselSectionVariants(), className)}
      aria-busy="true"
      aria-label="Loading reviews"
    >
      <Skeleton className="h-10 w-64 mx-auto mb-4" aria-hidden="true" />

      <div className={reviewsCarouselSkeletonGridVariants()}>
        {Array.from({ length: count }, (_, i) => (
          <Skeleton
            key={`review-skeleton-${i}`}
            className={reviewsCarouselSkeletonItemVariants()}
            aria-hidden="true"
          />
        ))}
      </div>
    </section>
  )
}
